import { useState } from "react";
import { Card, Form, Input, Button, Row, Col, Typography, message } from "antd";
import { useNavigate } from "react-router-dom";
import './Signup.css';
import logo from '../assets/lead-finder-white.jpg';

export default function ForgetPassword() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (values) => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      email: values.email
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch("https://api.app.exellius.com/api/auth/forgot-password", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        setLoading(false);
        console.log(result);
        message.success("Password reset instructions sent to your email");
        const encodedEmail = btoa(values.email);
        navigate(`/${encodedEmail}/reset-password`);
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
        message.error("An error occurred during the password reset process");
      });
  };

  return (
    <Row className="signup-container">
      {/* Left Side - Form */}
      <Col xs={24} md={12} className="signup-form-container">
        <Card className="signup-card">
          <div className="signup-logo">
            <img src={logo} alt="Logo" style={{height:"50px",width:"auto"}} />
          </div>
          <Typography.Title level={2} className="signup-title" style={{color:"black",fontWeight:800}}>Forget Password</Typography.Title>
          <Form form={form} onFinish={handleSubmit} layout="vertical">
            <Form.Item name="email" label="Email" rules={[{ required: true, type: "email", message: "Please enter a valid email" }]}> 
              <Input size="large" placeholder="Enter email" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" size="large" className="signup-button" block loading={loading}>Submit</Button>
            </Form.Item>
            <Form.Item>
              <Button type="default" size="large" className="signup-button" block onClick={() => navigate('/login')}>Back to Login</Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>

      {/* Right Side - Image */}
      <Col xs={0} md={12} className="signup-image-container">
        <div>
          <img src="https://app.success.ai/static/media/section1-3.39df0c32ebe092599f26.png" alt="Right Side" className="signup-image" />
          <div className="signup-text-container">
            <Typography.Title level={3} className="signup-text-title">Easily find great leads with our strong database</Typography.Title>
            <Typography.Text className="signup-text">Quickly find valuable leads with our rich database, making your search easier and boosting your growth.</Typography.Text>
          </div>
        </div>
      </Col>
    </Row>
  );
}
